import KibanaFilterModel from './osd-filter-model';
export default class IsFilterModel extends KibanaFilterModel {
    query;
    constructor(metadata) {
        super(metadata);
        if (!metadata.key)
            return;
        this.query = {
            match: {
                [metadata.key]: {
                    query: metadata.value,
                    type: metadata.type,
                },
            },
        };
    }
}
//# sourceMappingURL=is-filter-model.js.map